import { Data as ArticleData } from '@root/modules/article/types/article';

const getFakeArticleUrl = (article: ArticleData) => {
  if (article.settings?.redirectArticle && article.settings?.redirectArticle.url && article.settings?.redirectArticle.checked === true) {
    return article.settings.redirectArticle.url;
  } else if (article.settings?.fakeArticleTitle) {
    const href = article.settings?.fakeArticleTitle.match(/href="([^"]*")/g);
    if (href?.length) {
      const urlPattern = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-/]))?/;
      const url = href[0].replace(/(href="|")/gi, '');
      if (url && urlPattern.test(url)) {
        return url;
      }
    }
  }

  return false;
};

export default getFakeArticleUrl;
